function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { getBorderToken } from "../fundations/palette/colorTokens";
export const Tabs = {
    MuiTabs: {
        variants: [
            {
                props: {
                    variant: "fullWidth"
                },
                style: {
                    ".MuiTab-root": {
                        justifyContent: "start"
                    }
                }
            },
            {
                props: {
                    orientation: "horizontal"
                },
                style: ({ theme })=>({
                        borderLeft: 0,
                        ".MuiTabs-flexContainer": {
                            gap: theme.spacing(3)
                        },
                        ".MuiTab-root": {
                            padding: 0,
                            minWidth: 0
                        },
                        ".MuiTabs-indicator": {
                            paddingLeft: 2,
                            left: 0
                        }
                    })
            },
            {
                props: {
                    orientation: "vertical"
                },
                style: ({ theme })=>({
                        borderBottom: 0,
                        ".MuiTabs-flexContainer": {
                            gap: theme.spacing(1)
                        },
                        ".MuiTab-root": {
                            justifyContent: "start",
                            textAlign: "start",
                            borderLeft: 1,
                            borderColor: "divider"
                        },
                        ".MuiButtonBase-root": {
                            paddingLeft: theme.spacing(1)
                        },
                        ".MuiTabs-indicator": {
                            left: 0
                        }
                    })
            }
        ],
        styleOverrides: {
            root: ({ theme })=>({
                    borderLeft: `1px solid ${getBorderToken("border200", theme)}`,
                    borderBottom: `1px solid ${getBorderToken("border200", theme)}`,
                    ".MuiButtonBase-root.MuiTab-root": {
                        color: theme.palette.text.textBody,
                        "&.Mui-selected": {
                            color: theme.palette.text.primary
                        }
                    },
                    ".MuiButtonBase-root": {
                        minHeight: 40
                    }
                })
        }
    },
    MuiTab: {
        defaultProps: {
            iconPosition: "start"
        },
        styleOverrides: {
            root: ({ theme })=>_object_spread({
                    textTransform: "none"
                }, theme.typography.textSm)
        }
    }
};

//# sourceMappingURL=Tabs.js.map